<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign.gt-md="space-between center">
    <h1>Listar Examinadores</h1>
  </div>

  <inscricoes-listagem-examinadores-filtro
    [initialFilters]="currentFilters"
    [hideConcursoFilter]="!!currentFilters.concurso"
    (filterChanged)="handleFilterChange($event)">
  </inscricoes-listagem-examinadores-filtro>

  <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-0">
    <div>
      <button
        (click)="openDialog()"
        mat-raised-button
        color="primary"
        [disabled]="!selection.hasValue() || !currentFilters.concurso"
        matTooltipDisabled="This button is disabled"
        disableTooltipInteractivity="false"
        matBadgeColor="warn"
        [matBadgeHidden]="!selection.hasValue()"
        [matBadge]="selection.selected.length">
        Enviar Notificações
        <mat-icon iconPositionEnd>send</mat-icon>
      </button>
    </div>
    <div fxLayoutGap="10px">
      <button
        mat-stroked-button
        color="primary"
        routerLink="cadastrar-interno"
        [queryParamsHandling]="'preserve'">
        <mat-icon iconPositionStart>person_add</mat-icon>
        Examinador Unicamp
      </button>
      <button
        mat-stroked-button
        color="primary"
        routerLink="cadastrar-externo"
        [queryParamsHandling]="'preserve'">
        <mat-icon iconPositionStart>person_add</mat-icon>
        Examinador Externo
      </button>
    </div>
  </div>

  <mat-hint>Selecione um Concurso e, pelo menos, um Examinador a ser notificado.</mat-hint>

  <mat-card
    *ngIf="currentFilters.concurso && dataSource.data.length > 0 && !hasPresidente()"
    class="mat-elevation-2"
    class="alert-warning">
    <mat-card-content>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon color="warn">warning</mat-icon>
        <span>Atenção: Este concurso ainda não possui um presidente definido.</span>
      </div>
    </mat-card-content>
  </mat-card>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [hidden]="!currentFilters.concurso">
          <mat-checkbox
            color="primary"
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
            [disabled]="!currentFilters.concurso">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" [hidden]="!currentFilters.concurso">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
            [disabled]="!currentFilters.concurso">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nome }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
      </ng-container>

      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Matrícula</th>
        <td mat-cell *matCellDef="let row">{{ row.matricula }}</td>
      </ng-container>

      <ng-container matColumnDef="unidade">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unidade</th>
        <td mat-cell *matCellDef="let row">{{ row.unidade }}</td>
      </ng-container>

      <ng-container matColumnDef="titulacao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Titulação</th>
        <td mat-cell *matCellDef="let row">{{ getTitulacao(row.titulacao) }}</td>
      </ng-container>

      <ng-container matColumnDef="titulacaoData">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data da Titulação</th>
        <td mat-cell *matCellDef="let row">{{ row.titulacaoData | date : 'dd/MM/yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="papel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Papel</th>
        <td mat-cell *matCellDef="let row">{{ getPapel(row.papel) }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ getTipo(row.tipo) }}</td>
      </ng-container>

      <ng-container matColumnDef="concursoName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Concurso</th>
        <td mat-cell *matCellDef="let row">
          <app-ellipsis-tooltip [content]="row.concursoName" [maxLength]="50"></app-ellipsis-tooltip>
        </td>
      </ng-container>

      <ng-container matColumnDef="isNotificado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header justify="center">Notificado?</th>
        <td mat-cell *matCellDef="let row">
          <inscricoes-listagem-examinadores-icone-notificar
            [isNotificado]="row.isNotificado"
            [isNotificacaoVisualizada]="row.isNotificacaoVisualizada"
            [notificacaoVisualizadaAt]="row.notificacaoVisualizadaAt"
            [notificadoAt]="row.notificadoAt">
          </inscricoes-listagem-examinadores-icone-notificar>
        </td>
      </ng-container>

      <ng-container matColumnDef="isDeAcordo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>De Acordo?</th>
        <td mat-cell *matCellDef="let row">
          <div fxLayout="row" fxLayoutAlign="center center">
            <ng-container *ngIf="row.isDeAcordo; else naoDeAcordo">
              <mat-icon matTooltip="De acordo em: {{ row.deAcordoAt | date : 'short' }}" color="accent">check</mat-icon>
            </ng-container>
            <ng-template #naoDeAcordo><mat-icon color="warn">clear</mat-icon></ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action" *ngIf="canOpenOptions()">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            color="basic"
            [matMenuTriggerFor]="menu"
            title="Opções"
            *ngIf="row.papel === 'TITULAR' || row.papel === 'PRESIDENTE' || row.papel === 'SUPLENTE'">
            <mat-icon>settings</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              color="basic"
              title="Substituir por Suplente"
              (click)="handleOpenSubstitution(row)"
              *ngIf="row.papel !== 'SUPLENTE'">
              <mat-icon>person_edit</mat-icon>
              <span>Substituir por Suplente</span>
            </button>
            <button
              mat-menu-item
              color="basic"
              title="Definir como Presidente"
              (click)="definirPresidente(row)"
              *ngIf="!hasPresidenteInConcurso(row.concursoName) && row.papel !== 'SUPLENTE'">
              <mat-icon>star</mat-icon>
              <span>Definir como Presidente</span>
            </button>
            <button
              mat-menu-item
              color="basic"
              title="Transferir Presidência"
              (click)="handleOpenTransferirPresidencia(row)"
              *ngIf="row.papel === 'PRESIDENTE'">
              <mat-icon>swap_horiz</mat-icon>
              <span>Transferir Presidência</span>
            </button>
            <button
              mat-menu-item
              color="warn"
              title="Remover Comissão Julgadora"
              (click)="removerComissaoJulgadora(row)">
              <mat-icon>delete</mat-icon>
              <span>Remover</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9">
          <span *ngIf="currentFilters.nome"
            >Nenhum registro encontrado para a pesquisa: "{{ currentFilters.nome }}"</span
          >
          <span *ngIf="!currentFilters.nome">Nenhum registro disponível</span>
        </td>
      </tr>
    </table>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="20"
      [pageSizeOptions]="[10, 20, 50, 100]"
      (page)="handlePageEvent($event)"
      showFirstLastButtons></mat-paginator>
  </div>
</div>
